export const COURIERS_TAB = { id: 'couriers', name: 'Водители' }
export const ORDERS_TAB = { id: 'orders', name: 'Заказы' }
export const PROBLEMS_TAB = { id: 'problems', name: 'Проблемы' }
export const SIDEBAR_TABS = [COURIERS_TAB, ORDERS_TAB, PROBLEMS_TAB]

export const DELIVERY_MARKER_COLOR = '#2C53F5'
export const UNDELIVERED_DELIVERY_MARKER_COLOR = '#009DFF'
export const TAKE_MARKER_COLOR = '#EF7625'
export const UNASSIGNED_TAKE_MARKER_COLOR = '#D39042'
export const PROBLEM_MARKER_COLOR = '#FF0000'

export const AVAILABLE_COLORS = [
    '#0627AE',
    '#D753C5',
    '#AE0609',
    '#FF8080',
    '#06AE2D',
    '#AE5406',
    '#06AEAE',
    '#25AEF2',
    '#EB9318',
    '#9206AE'
]

export default {
    COURIERS_TAB,
    ORDERS_TAB,
    PROBLEMS_TAB,
    SIDEBAR_TABS,
    AVAILABLE_COLORS,
    DELIVERY_MARKER_COLOR,
    UNDELIVERED_DELIVERY_MARKER_COLOR,
    TAKE_MARKER_COLOR,
    UNASSIGNED_TAKE_MARKER_COLOR,
    PROBLEM_MARKER_COLOR,
}